import LiveLink from './LiveLink';

export default LiveLink;